export const SET_WEBSOCKET = 'SET_WEBSOCKET'
export const REMOVE_WEBSOCKET = 'REMOVE_WEBSOCKET'
export const CHAT_LOGOUT = 'CHAT_LOGOUT'
export const CHAT_LOGIN = 'CHAT_LOGIN'
export const SET_USERS_LIST = 'SET_USER_LIST'
export const SET_MESSAGES_LIST = 'SET_MESSAGES_LIST'
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const SET_CHAT_SETTINGS = 'SET_CHAT_SETTINGS'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const SET_USER_BLOCKED = 'SET_USER_BLOCKED'
export const SET_MESSAGE_DELETED = 'SET_MESSAGE_DELETED'
export const SET_IS_USER_CONNECTED = 'SET_IS_USER_CONNECTED'
export const SET_IS_SOCKET_OPENED = 'SET_IS_SOCKET_OPENED'
